<div class="sqlc-static">
  <hr class="line" [ngStyle]="{ background: newColor }" />

  <!-- The shared header, with the same affordances a dynamic dashboard's has.
       The Refresh button and the Help icon's config are inputs; the brand label
       and "Last refreshed" stamp are not — topnav reads those off FilterService,
       and this screen publishes nothing there because the review queue is
       cross-brand and has no single brand to report. -->
  <app-topnav
    [clientLogo]="clientLogo"
    [pagename]="dashboardTitle"
    [refreshTheDashboard]="true"
    [widgetHelpInfo]="topnavHelpInfo"
  ></app-topnav>

  <!-- Below the topnav the page is a fixed-height column on desktop: the filter
       row holds the top band and .sqlc-scroll underneath is the only thing that
       scrolls. Under 992px both collapse into one scrolling box — see the
       responsive block in the stylesheet. -->
  <div class="sqlc-body">
    <!-- ============================ FILTER BAR ============================ -->
    <div class="filter-bar">
      <span class="sf-label">Selected Filters</span>

      <span
        class="sf-nav"
        *ngIf="badgesOverflow"
        (click)="scrollBadges(-1)"
        title="Scroll left"
      >
        <svg width="16" height="16" viewBox="0 0 8 8" fill="none">
          <path
            d="M6.79059 7.11381C6.81139 7.06178 6.79965 7.00195 6.76179 6.96215L3.92262 3.99979L6.76151 1.03744C6.79965 0.997648 6.81111 0.93727 6.79058 0.885787C6.77005 0.833757 6.72125 0.799805 6.66739 0.799805L4.26742 0.799805C4.23196 0.799805 4.19808 0.814557 4.17302 0.840435L1.23972 3.9013C1.21386 3.92857 1.20078 3.96418 1.20078 3.9998C1.20078 4.03543 1.21384 4.07103 1.23972 4.09831L4.17302 7.15917C4.19808 7.18505 4.23196 7.1998 4.26742 7.1998L6.66739 7.1998C6.72125 7.19979 6.77005 7.16584 6.79059 7.11381Z"
            fill="#1363DF"
          />
        </svg>
      </span>

      <div class="badge-scroller" #badgeScroller>
        <!-- Every filter this screen has is named from the first frame. A chip
             only gains its count, its caret and its dropdown once that filter's
             values are in — until then it stands as the name alone, so the strip
             always says what the queue can be narrowed by. -->
        <div
          class="chip"
          *ngFor="let f of filters"
          [class.chip-empty]="!hasOptions(f)"
        >
          <div class="chip-toggle" (click)="toggleDropdown(f, $event)">
            <span class="chip-label mr-1">{{ f.label }}</span>
            <ng-container *ngIf="hasOptions(f)">
              <span
                class="chip-count"
                [style.background]="isPartial(f) ? '#FF9A3D' : '#1363df'"
                >{{ f.applied.size }}/{{ f.options.length }}</span
              >
              <span class="chip-caret">▾</span>
            </ng-container>
            <span class="chip-count chip-count-empty" *ngIf="!hasOptions(f)"
              >–</span
            >
          </div>
        </div>

        <div class="chip" (click)="openDateMenu($event)">
          <span class="chip-label date-chip">{{ dateRangeLabel }}</span>
          <span class="chip-caret">▾</span>
        </div>
      </div>

      <span
        class="sf-nav"
        *ngIf="badgesOverflow"
        (click)="scrollBadges(1)"
        title="Scroll right"
      >
        <svg width="16" height="16" viewBox="0 0 8 8" fill="none">
          <path
            d="M1.20941 7.11381C1.18861 7.06178 1.20035 7.00195 1.23821 6.96215L4.07738 3.99979L1.23849 1.03744C1.20035 0.997648 1.18889 0.93727 1.20942 0.885787C1.22995 0.833757 1.27875 0.799805 1.33261 0.799805L3.73258 0.799805C3.76804 0.799805 3.80192 0.814557 3.82698 0.840435L6.76028 3.9013C6.78614 3.92857 6.79922 3.96418 6.79922 3.9998C6.79922 4.03543 6.78616 4.07103 6.76028 4.09831L3.82698 7.15917C3.80192 7.18505 3.76804 7.1998 3.73258 7.1998L1.33261 7.1998C1.27875 7.19979 1.22995 7.16584 1.20941 7.11381Z"
            fill="#1363DF"
          />
        </svg>
      </span>

      <!-- Question search. In the bar as an input rather than as a chip because
           there is no option list behind it to drop down — it matches free text
           against the prompt. -->
      <div class="sf-search">
        <span class="sf-search-icon">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#737D88" stroke-width="2">
            <circle cx="11" cy="11" r="7" />
            <path d="M21 21l-4.35-4.35" />
          </svg>
        </span>
        <input
          type="text"
          placeholder="Search question text"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange()"
        />
      </div>

      <span
        class="chip reset-chip"
        *ngIf="anyPartial"
        (click)="resetFilters()"
        title="Reset all filters"
      >
        <span class="reset-x">✕</span> Reset
      </span>

      <!-- What this screen reads and what a verdict does — see noteText. -->
      <!-- <div class="note-box" [title]="noteText">
        {{ noteText }}
      </div> -->
    </div>

    <!-- Fixed dropdown for the open badge (kept outside the scroller so it is
         not clipped). -->
    <div class="filter-backdrop" *ngIf="openFilter" (click)="closeDropdown()"></div>
    <div
      class="badge-menu"
      *ngIf="openFilter as f"
      [style.left.px]="menuPos.left"
      [style.top.px]="menuPos.top"
      (click)="$event.stopPropagation()"
    >
      <ng-container
        *ngTemplateOutlet="filterControls; context: { f: f }"
      ></ng-container>
    </div>

    <!-- Date badge popup — the shared app-dual-calendar, same as filter-badges -->
    <div class="filter-backdrop" *ngIf="dateMenuOpen" (click)="closeDateMenu()"></div>
    <div
      class="date-menu"
      *ngIf="dateMenuOpen"
      [style.left.px]="datePos.left"
      [style.top.px]="datePos.top"
      (click)="$event.stopPropagation()"
    >
      <app-dual-calendar
        [DateConfig]="dateConfig"
        [selectedData]="dateSelectedData"
        (applyFilter)="onCalendarApply($event)"
      ></app-dual-calendar>
    </div>

    <!-- Shared Include / Exclude / Clear buttons (badge dropdown + panel
         ng-select), lifted verbatim from the other two static screens so the
         three filter bars are one control rendered three times. -->
    <ng-template #ieButtons let-f="f" let-sc="sc">
      <button
        class="btn include du-multi-select-btn"
        [class.disabled]="!canInclude(f)"
        [disabled]="!canInclude(f)"
        title="Include"
        (click)="$event.stopPropagation(); applyInclude(f, sc)"
      >
        <svg width="25" height="15" viewBox="0 0 15 15" fill="none">
          <rect x="7" width="8" height="3" fill="#1363DF" />
          <rect x="7" y="12" width="8" height="3" fill="#1363DF" />
          <path
            d="M6.15338 6.46002L-5.28031e-07 6.46003L-3.46196e-07 8.53998L6.15338 8.53998L3.76241 11.0228L5.18496 12.5L10 7.5L5.18496 2.5L3.76241 3.9772L6.15338 6.46002Z"
            fill="#1363DF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.62947 4L9.5185 7H5V6.46003L6.15338 6.46002L5 5.26233V4H6.62947ZM8.01778 4H13V7H10.8663C10.8265 6.93118 10.7778 6.86608 10.7203 6.80634L8.01778 4Z"
            fill="#1363DF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.5185 8L6.62947 11H6V8.69925L6.15338 8.53998H6V8H9.5185ZM10.8663 8H14V11H8.01778L10.7203 8.19366C10.7778 8.13392 10.8265 8.06882 10.8663 8Z"
            fill="#1363DF"
          />
        </svg>
      </button>

      <button
        class="btn exclude du-multi-select-btn"
        [class.disabled]="!canExclude(f)"
        [disabled]="!canExclude(f)"
        title="Exclude"
        (click)="$event.stopPropagation(); applyExclude(f, sc)"
      >
        <svg width="25" height="15" viewBox="0 0 15 15" fill="none">
          <rect width="8" height="3" fill="#D11044" />
          <rect y="12" width="8" height="3" fill="#D11044" />
          <path
            d="M11.1534 6.46002L5 6.46003L5 8.53998L11.1534 8.53998L8.76241 11.0228L10.185 12.5L15 7.5L10.185 2.5L8.76241 3.9772L11.1534 6.46002Z"
            fill="#D11044"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5 7H10V6.46003L5 6.46003V7ZM10 5.26234L8.78436 4H10V5.26234ZM4 7H2V4H7.76266C7.76816 4.24237 7.86131 4.48312 8.0421 4.67086L8.80207 5.46003L5 5.46003C4.44772 5.46003 4 5.90774 4 6.46003V7Z"
            fill="#D11044"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.78436 11H9V10.7761L8.78436 11ZM9 8.53998L5 8.53998V8H9V8.53998ZM7.76267 11H1V8H4V8.53998C4 9.09226 4.44772 9.53997 5 9.53998L8.80207 9.53998L8.0421 10.3291C7.86131 10.5169 7.76816 10.7576 7.76267 11Z"
            fill="#D11044"
          />
        </svg>
      </button>

      <button
        class="btn exclude du-multi-select-btn"
        [class.disabled]="f.checked.length === 0"
        [disabled]="f.checked.length === 0"
        title="Clear selection"
        (click)="clearChecked(f, $event)"
      >
        <svg width="25" height="15" viewBox="0 0 16 16" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.1233 0C15.6075 0 16 0.392499 16 0.876682C16 1.05902 15.9432 1.23684 15.8373 1.3854L12.2592 6.40765C11.9677 6.35237 11.6669 6.32344 11.3594 6.32344C8.70842 6.32344 6.55938 8.47248 6.55938 11.1234C6.55938 12.7503 7.3687 14.1881 8.60667 15.0562L7.97832 15.4751C7.19837 15.995 6.14461 15.7843 5.62468 15.0044C5.43971 14.7268 5.34054 14.401 5.33964 14.0675L5.32513 8.72486L0.159683 1.38108C-0.11886 0.985049 -0.0236423 0.438156 0.372391 0.159613C0.520046 0.055766 0.696221 0 0.876751 0H15.1233Z"
            fill="#D11044"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.2 14.3219C12.9673 14.3219 14.4 12.8892 14.4 11.1219C14.4 9.35456 12.9673 7.92188 11.2 7.92188C9.43269 7.92188 8 9.35456 8 11.1219C8 12.8892 9.43269 14.3219 11.2 14.3219ZM11.5953 11.4889H12.8V10.7642H11.5953L11.6 10.7643H10.8L10.7953 10.7642H9.60001V11.4889L10.7953 11.4889L11.5953 11.4889Z"
            fill="#D11044"
          />
        </svg>
      </button>
    </ng-template>

    <!-- Shared filter selection UI, reused by the badge dropdown above and the
         right-side panel below. -->
    <ng-template #filterControls let-f="f">
      <div class="filter-controls">
        <div class="header">
          <ng-container
            *ngTemplateOutlet="ieButtons; context: { f: f }"
          ></ng-container>
        </div>

        <div class="search-container">
          <input
            class="search-bar"
            type="text"
            placeholder="Search..."
            [(ngModel)]="f.search"
          />
        </div>

        <div class="select-all-container" (click)="toggleSelectAll(f, $event)">
          <input
            type="checkbox"
            [checked]="allChecked(f)"
            (click)="toggleSelectAll(f, $event)"
          />
          <span>Select All</span>
        </div>

        <div
          class="menu-options"
          [class.dynamicHeight]="filteredOptions(f).length > 9"
        >
          <div
            class="du-badge-option"
            *ngFor="let o of filteredOptions(f)"
            [class.selected]="isChecked(f, o)"
            (click)="toggleOption(f, o, $event)"
          >
            <input
              type="checkbox"
              [checked]="isChecked(f, o)"
              (click)="toggleOption(f, o, $event)"
            />
            <span>{{ o }}</span>
          </div>
          <div class="no-data" *ngIf="filteredOptions(f).length === 0">
            No data found
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Everything from here down is the scrolling region. The filter row above
         is deliberately outside it, so the scrollbar starts below the bar rather
         than running behind it. -->
    <div class="sqlc-scroll">
      <!-- ============================ KPI ROW ============================
           Every card reads the one tally, so they all wait on the same `loading`
           flag — but each carries its own loader rather than the row sharing
           one, so the cards stay in place and only the numbers are pending.

           Six cards: the total, then one per status in CACHE_STATUS_TAB_ORDER, so
           the row names all five states the tab strip below offers.

           READ-ONLY. The cards report, they do not filter — the status tabs are
           the one control that narrows this screen, and a card that also selected
           would be a second, less obvious way to do the same thing. Nothing here
           is clickable, focusable or highlighted; the only live element in a card
           is its Help icon.

           NO figure here moves with the open tab (see buildKpis) — each reports
           across the current filters, so the row stays a summary of the whole
           selection while the tab narrows only the queue below it. Picking a tab
           leaves all six numbers exactly as they were. -->
      <div class="kpi-row">
        <div class="kpi-card" *ngFor="let k of kpis">
          <app-progress-indefinite
            class="card-loader"
            *ngIf="loading"
          ></app-progress-indefinite>

          <ng-container *ngIf="!loading">
            <!-- Help, from assets/help_info/sql-cache-static.json — the same
                 affordance the real KPI cards carry (card2kpi). Absent on a card
                 the JSON has no entry for, rather than opening an empty one. -->
            <div class="kpi-info" *ngIf="k.help">
              <mat-icon
                svgIcon="info_circle"
                matTooltip="Help"
                matTooltipClass="sqlc-tip"
                [matMenuTriggerFor]="cardHelpMenu"
                (click)="showCardHelp(k.help)"
              ></mat-icon>
            </div>

            <div class="kpi-body">
              <mat-icon
                class="kpi-icon"
                [svgIcon]="k.icon"
                [style.color]="k.color"
              ></mat-icon>
              <div class="kpi-text">
                <div class="kpi-value" [style.color]="k.color">{{ k.value }}</div>
                <div class="kpi-heading">{{ k.heading }}</div>
              </div>
            </div>

            <mat-icon class="kpi-watermark" [svgIcon]="k.icon"></mat-icon>
          </ng-container>
        </div>

        <!-- Usage: two counts rather than a heading and a number, because they
             answer one question (how heavy this slice of the cache is) and
             neither is the card's headline.
             No spend figure — see the `usage` field on the component. -->
        <!-- <div class="kpi-card usage-card">
          <app-progress-indefinite
            class="card-loader"
            *ngIf="loading"
          ></app-progress-indefinite>

          <ng-container *ngIf="!loading">
            <div class="kpi-info" *ngIf="usageHelp">
              <mat-icon
                svgIcon="info_circle"
                matTooltip="Help"
                [matMenuTriggerFor]="cardHelpMenu"
                (click)="showCardHelp(usageHelp)"
              ></mat-icon>
            </div>

            <div class="kpi-body">
              <mat-icon
                class="kpi-icon"
                svgIcon="pulse_circle"
                [style.color]="usageColor"
              ></mat-icon>

              <div class="usage-inner">
                <div class="usage-title">Usage</div>
                <div class="usage-cols">
                  <div>
                    <div class="u-label">Tokens</div>
                    <div class="u-value">{{ usage.totalTokens | number }}</div>
                  </div>
                  <div>
                    <div class="u-label">Avg time</div>
                    <div class="u-value">
                      {{ usage.avgSeconds | number: "1.1-1" }}s
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <mat-icon class="kpi-watermark" svgIcon="pulse_circle"></mat-icon>
          </ng-container>
        </div> -->
      </div>

      <!-- ============================ REVIEW PANEL =========================
           Hosts the same shared <icon-chart> header as the other static screens'
           panels, so Fullscreen and the export menu are the same components with
           the same behaviour. #reviewFsEl is what icon-chart promotes;
           #reviewExportEl is the subtree it rasterises for "Export as Image". -->
      <div class="panel review-panel">
        <article
          #reviewFsEl
          fullscreen-able
          class="review-fs"
          [class.is-active]="reviewFullscreen"
        >
          <icon-chart
            [headerConfig]="reviewHeaderConfig"
            [heading]="reviewTitle"
            [chartName]="'SqlCacheReviewQueue'"
            [item]="reviewItem"
            [staticInfo]="reviewHelp"
            [data]="reviewExcelRows"
            [excelConfig]="reviewExcelConfig"
            [config]="reviewExportEl"
            [expand]="reviewFsEl"
            [fullscreen]="reviewFullscreen"
            (screenChanges)="onReviewFullscreen()"
          ></icon-chart>

          <div #reviewExportEl class="review-export">
            <div class="panel-state" *ngIf="loading">
              <app-progress-indefinite></app-progress-indefinite>
            </div>
            <div class="panel-state" *ngIf="noData">
              <span class="bg-text">There is no cached query to review</span>
            </div>

            <!-- ========================== STATUS TABS ======================
                 The queue's own narrowing, as the app's segmented pill track
                 (tabDesignTwo / emd-pill-group). Counts are questions, not
                 queries, because a question is what the list below renders one
                 row of — and they are counted across the whole view rather than
                 under the open tab, so an unopened pill still says what opening
                 it would bring.

                 INSIDE the panel, not above it. Two reasons, and the first is
                 the one that matters: icon-chart promotes #reviewFsEl to
                 fullscreen, so anything outside that element is simply not on
                 screen there — the tabs used to vanish the moment the panel was
                 expanded, taking the only way back to All with them. Being
                 inside #reviewExportEl also puts them in "Export as Image", so
                 an exported queue says which statuses it was filtered to.

                 A radiogroup rather than a tablist: picking a status filters the
                 one list below, it does not switch between panels. Same state as
                 the KPI cards above (`statusTab`), so picking either moves both.

                 All five pills are always rendered, even at a count of 0 — the
                 strip is the filter's vocabulary, not a report on this response,
                 and a pill that came and went with the chips would move every pill
                 after it sideways under the reviewer's cursor.

                 `data-label` on the label span reserves the BOLD width up front
                 — the 500 -> 600 weight change on selection would otherwise
                 widen the active pill and nudge every pill after it. -->
            <div
              class="du-tabs"
              role="radiogroup"
              aria-label="Cache status"
              *ngIf="!loading && !noData"
            >
              <!-- The unfiltered tab, and the one a fresh visit opens on. Rendered
                   here rather than as the first entry of `tabs`, so that array stays
                   exactly the statuses and buildTabs() has no null key to special-
                   case. Its count is the whole list, not a status's. -->
              <button
                type="button"
                role="radio"
                class="du-tab"
                [class.active]="!statusTab"
                [attr.aria-checked]="!statusTab"
                (click)="selectTab(null)"
              >
                <span class="tab-label" data-label="All">All</span>
                <span class="n">{{ viewGroups.length }}</span>
              </button>

              <button
                type="button"
                role="radio"
                class="du-tab"
                *ngFor="let t of tabs"
                [class.active]="statusTab === t.key"
                [attr.aria-checked]="statusTab === t.key"
                (click)="selectTab(t.key)"
              >
                <span class="tab-dot" *ngIf="t.dot" [style.background]="t.dot"></span>
                <span class="tab-label" [attr.data-label]="t.label">{{ t.label }}</span>
                <span class="n">{{ t.count }}</span>
              </button>
            </div>

            <div class="review-card" *ngIf="!loading && !noData">
              <!-- ---------------------------- LIST PANE ------------------- -->
              <div class="list-pane">
                <div class="list-count">
                  {{ listGroups.length }} question{{
                    listGroups.length === 1 ? "" : "s"
                  }}
                </div>

                <!-- Where the row just went. A verdict moves a question into the
                     tab its new status belongs to, so on a status tab the row the
                     reviewer was reading leaves the list — which on its own looks
                     the same as a write that failed. See `movedNotice`. -->
                <div class="moved-notice" *ngIf="movedNotice">
                  {{ movedNotice }}
                </div>

                <!-- Two readings, because the date range is the request and the
                     filters are not: an empty response is a window with nothing
                     cached in it, which no chip can undo. See listEmptyText. -->
                <div class="list-empty" *ngIf="listGroups.length === 0">
                  {{ listEmptyText }}
                </div>

                <!-- The badge and the stripe report `listedStatus`, i.e. the
                     status that put this row in the list — the open tab's, or the
                     worst across the queries while the list is on All. A row under
                     the Approved tab badged "Rejected" was the tab contradicting
                     its own result; see CacheGroup.listedStatus. -->
                <button
                  type="button"
                  class="list-item"
                  *ngFor="let g of listGroups"
                  [class.active]="g.questionId === selectedId"
                  [style.border-left-color]="statusDot(g.listedStatus)"
                  (click)="selectGroup(g)"
                >
                  <div class="list-item-top">
                    <span
                      class="du-badge"
                      [ngClass]="statusBadgeClass(g.listedStatus)"
                      >{{ statusLabel(g.listedStatus) }}</span
                    >
                    <span class="list-item-time">{{
                      shortTime(g.timestamp)
                    }}</span>
                  </div>

                  <div class="list-item-q" [title]="g.promptText">
                    {{ g.promptText }}
                  </div>

                  <div class="list-item-meta">
                    {{ g.project || "—" }}
                    <span class="sep" *ngIf="g.teamName">·</span>
                    <ng-container *ngIf="g.teamName">{{ g.teamName }}</ng-container>
                  </div>

                  <div class="list-item-bottom">
                    <!-- Only where there is more than one query: a "1 query" chip
                         on every row would be noise on the common case.

                         Under a status tab it reads "1 of 3" — how many of the
                         question's queries the tab actually matched — because the
                         badge beside it now names one status while the row still
                         holds three queries, and without the fraction "3 queries"
                         beside an Approved badge reads as three approved ones. The
                         dots stay all-inclusive either way, so a mixed question is
                         still visibly mixed. -->
                    <span class="mini-chip" *ngIf="g.queries.length > 1">
                      <ng-container *ngIf="statusTab">
                        {{ g.listedMatches }} of {{ g.queries.length }}
                      </ng-container>
                      <ng-container *ngIf="!statusTab">
                        {{ g.queries.length }} queries
                      </ng-container>
                      <span class="status-dots">
                        <span
                          *ngFor="let q of g.queries"
                          [style.background]="statusDot(q.status)"
                        ></span>
                      </span>
                    </span>
                    <span class="mini-chip approved" *ngIf="g.approvedCount > 0">
                      ✓ {{ g.approvedCount }}/{{ g.queries.length }} approved
                    </span>
                    <span class="mini-chip rejected" *ngIf="g.rejectedCount > 0">
                      ✕ {{ g.rejectedCount }}/{{ g.queries.length }} rejected
                    </span>
                  </div>
                </button>
              </div>

              <!-- --------------------------- DETAIL PANE ------------------ -->
              <div class="detail-pane">
                <div class="detail-empty" *ngIf="!selectedGroup">
                  Select a question from the list to review its queries, SQL and
                  metadata.
                </div>

                <ng-container *ngIf="selectedGroup as g">
                  <div class="detail-head">
                    <div class="detail-meta-row">
                      <span>{{ g.project || "no project" }}</span>
                      <span class="sep">•</span><span>brand {{ g.brandKey || "—" }}</span>
                      <span class="sep">•</span><span>{{ g.teamName || "—" }}</span>
                      <span class="sep">•</span><span>schema {{ g.schemaVersion || "—" }}</span>
                      <span class="sep">•</span
                      ><span
                        >{{ g.queries.length }} quer{{
                          g.queries.length === 1 ? "y" : "ies"
                        }}</span
                      >
                    </div>
                    <div class="detail-question">{{ g.promptText }}</div>
                  </div>

                  <!-- Query tabs, only where the question was answered more than
                       once — one tab over one query is chrome with nothing to
                       switch between. -->
                  <div class="query-tabs-wrap" *ngIf="g.queries.length > 1">
                    <div class="query-tabs">
                      <div
                        class="query-tab"
                        *ngFor="let q of g.queries; let i = index"
                        [class.active]="q.message_id === activeQuery?.message_id"
                        (click)="selectQuery(q.message_id, $event)"
                      >
                        <span
                          class="qdot"
                          [style.background]="statusDot(q.status)"
                        ></span>
                        Query {{ i + 1 }}
                        <!-- Signed off, and only that: a query still at GOOD / BAD
                             (ready for review) carries no mark, because the mark is
                             what says a reviewer is done with it. Which way it is
                             proposed is the dot's colour — see CacheQuery.approved. -->
                        <span class="qcheck" *ngIf="q.approved">✓</span>
                        <span class="qcross" *ngIf="q.rejected">✕</span>
                      </div>
                    </div>
                  </div>

                  <ng-container *ngIf="activeQuery as q">
                    <div class="query-card">
                      <div class="query-head">
                        <span class="query-head-label" *ngIf="g.queries.length > 1"
                          >Query {{ activeIndex + 1 }} of {{ g.queries.length }}</span
                        >
                        <span
                          class="du-badge"
                          [ngClass]="statusBadgeClass(q.status)"
                          [title]="'cache_status: ' + (q.rawStatus || q.status)"
                          >{{ statusLabel(q.status) }}</span
                        >
                        <span class="du-badge badge-neutral" *ngIf="q.ingested"
                          >Ingested</span
                        >
                        <span
                          class="du-badge badge-warn"
                          *ngIf="q.needsClarification"
                          title="The assistant asked for clarification before answering"
                          >Needs clarification</span
                        >
                      </div>

                      <!-- SQL. A message that cached none says so rather than
                           showing an empty code block.

                           Copy sits on the code block itself, not in the button
                           row: it acts on the SQL and nothing else, so it belongs
                           where the SQL is. It is a sibling of the <pre> rather
                           than a child of it because the block scrolls — a child
                           would scroll away with the code it copies. -->
                      <div class="sql-block">
                        <div class="section-label">
                          {{ q.correctedSql ? "Previous SQL" : "SQL" }}
                        </div>

                        <div class="sql-missing" *ngIf="!q.sql">
                          No SQL was cached for this message.
                        </div>

                        <ng-container *ngIf="q.sql">
                          <div class="sql-code-wrap">
                            <pre class="sql-code">{{ q.sql }}</pre>
                            <button
                              type="button"
                              class="sql-copy"
                              [class.is-copied]="copiedId === q.message_id"
                              [title]="
                                copiedId === q.message_id
                                  ? 'Copied'
                                  : 'Copy this SQL'
                              "
                              (click)="copySql(q, $event)"
                            >
                              {{ copiedId === q.message_id ? "✓ Copied" : "Copy" }}
                            </button>
                          </div>

                          <div class="section-label" *ngIf="q.correctedSql">
                            Corrected SQL
                          </div>
                          <div class="sql-code-wrap" *ngIf="q.correctedSql">
                            <pre class="sql-code">{{ q.correctedSql }}</pre>
                            <button
                              type="button"
                              class="sql-copy"
                              [class.is-copied]="
                                copiedCorrectedId === q.message_id
                              "
                              [title]="
                                copiedCorrectedId === q.message_id
                                  ? 'Copied'
                                  : 'Copy corrected SQL'
                              "
                              (click)="copyCorrectedSql(q, $event)"
                            >
                              {{
                                copiedCorrectedId === q.message_id
                                  ? "✓ Copied"
                                  : "Copy"
                              }}
                            </button>
                          </div>

                          <!-- The correction box: the query this message SHOULD
                               have cached, opened by Correction in the bar below.

                               Under the SQL it corrects, not in a dialog: the two
                               are read against each other line by line, and a
                               reviewer fixing a join condition needs the original
                               on screen while they type. Seeded with the cached
                               query (toggleCorrection) so the common case is an
                               edit rather than a retype.

                               Submit posts the APPROVE call with the corrected
                               query attached — a correction is an approval with a
                               replacement, not a third verdict — so the box carries
                               its own failure line rather than borrowing the bar's:
                               a refused write leaves the reviewer holding the query
                               they typed. -->
                          <div
                            class="sql-correction"
                            *ngIf="isCorrecting(q.message_id)"
                          >
                            <div class="section-label corr-label">
                              Corrected SQL
                            </div>
                            <textarea
                              class="corr-input"
                              rows="9"
                              spellcheck="false"
                              placeholder="The query this message should have cached"
                              [(ngModel)]="correctionDraft"
                              [disabled]="isSavingCorrection(q.message_id)"
                            ></textarea>

                            <div
                              class="corr-error"
                              *ngIf="
                                !isSavingCorrection(q.message_id) &&
                                correctionErrors[q.message_id]
                              "
                            >
                              <span class="ve-ico" aria-hidden="true">!</span>
                              <span
                                ><b>Not recorded</b> —
                                {{ correctionErrors[q.message_id] }}</span
                              >
                            </div>

                            <div class="corr-actions">
                              <span class="corr-hint">
                                Submitting approves this message with the query
                                above.
                              </span>
                              <button
                                type="button"
                                class="corr-btn corr-cancel"
                                [disabled]="isSavingVerdict(q.message_id)"
                                title="Discard this correction and close the box"
                                (click)="cancelCorrection()"
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                class="corr-btn corr-submit"
                                [class.is-posting]="
                                  isSavingCorrection(q.message_id)
                                "
                                [disabled]="
                                  isSavingVerdict(q.message_id) ||
                                  correctionEmpty
                                "
                                title="Approve this message with the corrected query above"
                                (click)="submitCorrection(g, q)"
                              >
                                <span
                                  class="vbtn-spin corr-spin"
                                  *ngIf="isSavingCorrection(q.message_id)"
                                ></span>
                                <span>{{
                                  isSavingCorrection(q.message_id)
                                    ? "Submitting…"
                                    : "Submit and Approve"
                                }}</span>
                              </button>
                            </div>
                          </div>

                          <!-- The verdict, in a bar of its own rather than two
                               buttons trailing off the end of the SQL.

                               It reads as a statement plus its controls: on the
                               left what this query's verdict IS and what can be
                               done about it, on the right the three controls that
                               change it. The buttons alone could not carry that —
                               a reviewer had to decode which one was filled, and
                               "nobody has graded this yet" had no words at all.

                               Reject sits left of Approve: the affirmative is the
                               one a reviewer reaches for most, and it gets the
                               outside position. Correction sits outside both, on
                               the left, because it is the one that does not settle
                               anything by itself — it opens the box the corrected
                               query is typed into. Both are held while either is in
                               flight — a verdict is one request, and a second
                               click during it would be a race over the same
                               message — but only the one that was clicked spins.
                               See isSavingOp(). -->
                          <div
                            class="verdict-bar"
                            *ngIf="!isCorrecting(q.message_id)"
                            [class.is-busy]="isSavingVerdict(q.message_id)"
                          >
                            <div
                              class="verdict-now"
                              [ngClass]="verdictTone(q)"
                            >
                              <span class="vn-mark" aria-hidden="true">{{
                                verdictMark(q)
                              }}</span>
                              <span class="vn-copy">
                                <span class="vn-head">{{
                                  verdictHeading(q)
                                }}</span>
                                <!-- Titled as well as shown: it ellipsises on a
                                     narrow pane, and the sentence it loses the
                                     end of is the one saying what to do next. -->
                                <span
                                  class="vn-sub"
                                  [title]="verdictSubtext(q)"
                                  >{{ verdictSubtext(q) }}</span
                                >
                              </span>
                            </div>

                            <div class="verdict-actions">
                              <!-- Correction opens the box under the SQL rather
                                   than posting anything itself: what it changes is
                                   the query being approved, and that has to be
                                   typed before there is a verdict to record. It
                                   toggles, so the same button backs out of it, and
                                   it carries no is-on fill in the verdict hues —
                                   an open editor is not a verdict in force. Held
                                   with the other two while any write is out; the
                                   spinner for a correction belongs to the box's
                                   own Submit. -->
                              <button
                                type="button"
                                class="vbtn vbtn-correct"
                                [class.is-open]="isCorrecting(q.message_id)"
                                [disabled]="isSavingVerdict(q.message_id)"
                                [attr.aria-expanded]="isCorrecting(q.message_id)"
                                title="Approve this message with a corrected query — opens a box under the SQL"
                                (click)="toggleCorrection(q)"
                              >
                                <span class="vbtn-ico" aria-hidden="true"
                                  >✎</span
                                >
                                <span class="vbtn-text">Correction</span>
                              </button>

                              <button
                                type="button"
                                class="vbtn vbtn-reject"
                                [class.is-on]="q.rejected"
                                [class.is-posting]="
                                  isSavingOp(q.message_id, 'reject')
                                "
                                [disabled]="isSavingVerdict(q.message_id)"
                                [attr.aria-pressed]="q.rejected"
                                title="Record this cached query as wrong — sets its cache status to Rejected"
                                (click)="setVerdict(g, q, 'reject')"
                              >
                                <span class="vbtn-ico" aria-hidden="true">
                                  <span
                                    class="vbtn-spin"
                                    *ngIf="
                                      isSavingOp(q.message_id, 'reject')
                                    "
                                  ></span>
                                  <ng-container
                                    *ngIf="
                                      !isSavingOp(q.message_id, 'reject')
                                    "
                                    >✕</ng-container
                                  >
                                </span>
                                <span class="vbtn-text">{{
                                  q.rejected ? "Rejected" : "Reject"
                                }}</span>
                              </button>

                              <button
                                type="button"
                                class="vbtn vbtn-approve"
                                [class.is-on]="q.approved"
                                [class.is-posting]="
                                  isSavingOp(q.message_id, 'approve')
                                "
                                [disabled]="isSavingVerdict(q.message_id)"
                                [attr.aria-pressed]="q.approved"
                                title="Record this cached query as correct — sets its cache status to Approved"
                                (click)="setVerdict(g, q, 'approve')"
                              >
                                <span class="vbtn-ico" aria-hidden="true">
                                  <span
                                    class="vbtn-spin"
                                    *ngIf="
                                      isSavingOp(q.message_id, 'approve')
                                    "
                                  ></span>
                                  <ng-container
                                    *ngIf="
                                      !isSavingOp(q.message_id, 'approve')
                                    "
                                    >✓</ng-container
                                  >
                                </span>
                                <span class="vbtn-text">{{
                                  q.approved ? "Approved" : "Approve"
                                }}</span>
                              </button>
                            </div>
                          </div>

                          <!-- A failed write, and only that. The in-flight and
                               idle wordings moved into the bar above, where they
                               sit beside the verdict they describe; a failure gets
                               a line of its own because it is the one state a
                               reviewer has to act on, and it is never silent — the
                               flags only flip on a verdict the API accepted. -->
                          <div
                            class="verdict-error"
                            *ngIf="
                              !isSavingVerdict(q.message_id) &&
                              verdictErrors[q.message_id]
                            "
                          >
                            <span class="ve-ico" aria-hidden="true">!</span>
                            <span
                              ><b>Not recorded</b> —
                              {{ verdictErrors[q.message_id] }}</span
                            >
                          </div>
                        </ng-container>
                      </div>

                      <!-- What the pipeline recorded about this message. The
                           reviewer's question after "is the SQL right" is "who
                           has already touched it", so that is on screen rather
                           than a click away. -->
                      <div class="meta-block">
                        <div class="section-label">Message</div>
                        <!-- Label and value each in their own grid cell, so every
                             value in a column starts at the same x and an id that
                             has to wrap wraps inside its own column instead of
                             running under its label. The ids and the S3 key are
                             monospaced: they are compared character by character
                             rather than read, and the even glyph width is what
                             makes two of them comparable at a glance. -->
                        <div class="meta-grid">
                          <div>
                            <span class="k">Conversation</span>
                            <span class="v v-id">{{ g.conversationId || "—" }}</span>
                          </div>
                          <div>
                            <span class="k">Message</span>
                            <span class="v v-id">{{ q.message_id || "—" }}</span>
                          </div>
                          <div>
                            <span class="k">User</span>
                            <span class="v">{{ g.userId || "—" }}</span>
                          </div>
                          <div>
                            <span class="k">Cached at</span>
                            <span class="v">{{ fullTime(q.timestamp) }}</span>
                          </div>
                          <div>
                            <span class="k">Tokens</span>
                            <span class="v"
                              >{{ q.totalTokens | number }}
                              <span class="v-sub"
                                >({{ q.inputTokens | number }} in /
                                {{ q.outputTokens | number }} out)</span
                              ></span
                            >
                          </div>
                          <div>
                            <span class="k">Time</span>
                            <span class="v"
                              >{{ q.llmTime | number: "1.0-3" }}s
                              <span class="v-sub">LLM</span> /
                              {{ q.dbTime | number: "1.0-3" }}s
                              <span class="v-sub">DB</span></span
                            >
                          </div>
                          <div *ngIf="q.cacheUpdatedAt">
                            <span class="k">Cache updated</span>
                            <span class="v">{{ q.cacheUpdatedAt }}</span>
                          </div>
                          <div *ngIf="q.approvedBy">
                            <span class="k">Approved by</span>
                            <span class="v"
                              >{{ q.approvedBy }}
                              <span class="v-sub" *ngIf="q.approvedAt"
                                >({{ q.approvedAt }})</span
                              ></span
                            >
                          </div>
                          <div *ngIf="q.rejectedBy">
                            <span class="k">Rejected by</span>
                            <span class="v"
                              >{{ q.rejectedBy }}
                              <span class="v-sub" *ngIf="q.rejectedAt"
                                >({{ q.rejectedAt }})</span
                              ></span
                            >
                          </div>
                          <div *ngIf="q.feedback" class="meta-wide">
                            <span class="k">Feedback</span>
                            <span class="v">{{ q.feedback }}</span>
                          </div>
                          <div *ngIf="q.resultSummary" class="meta-wide">
                            <span class="k">Result</span>
                            <span class="v">{{ q.resultSummary }}</span>
                          </div>
                          <div *ngIf="q.s3Key" class="meta-wide">
                            <span class="k">S3 key</span>
                            <span class="v v-id">{{ q.s3Key }}</span>
                          </div>
                        </div>

                        <!-- Per-model calls and tokens, off `by_model`. Named by
                             the tail of the inference-profile ARN — the rest is a
                             bedrock resource path and says nothing a reviewer
                             reads. No cost column: see CacheModelUsage. -->
                        <ng-container *ngIf="q.models.length">
                          <div class="section-label model-label">Model usage</div>
                          <table class="model-table">
                            <thead>
                              <tr>
                                <th>Model</th>
                                <th>Calls</th>
                                <th>Input</th>
                                <th>Output</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let m of q.models">
                                <td [title]="m.name">{{ m.name }}</td>
                                <td>{{ m.calls }}</td>
                                <td>{{ m.input_tokens | number }}</td>
                                <td>{{ m.output_tokens | number }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
    <!-- /.sqlc-scroll -->
  </div>
  <!-- /.sqlc-body -->

  <!-- ===================== RIGHT FILTER PANEL (like app-filter) ========== -->
  <div
    class="filter-panel-backdrop"
    *ngIf="filterPanelOpen"
    (click)="closeFilterPanel()"
  ></div>

  <aside
    class="filter-panel"
    [class.open]="filterPanelOpen"
    #fpEl
    [style.width.px]="panelWidth"
  >
    <!-- drag the left edge to resize (same as app-filter) -->
    <div
      class="fp-resize"
      (resize)="onResizeSide($event)"
      [targetElement]="fpEl"
      [direction]="AngularResizeElementDirection.LEFT"
      title="Drag to resize"
    ></div>

    <!-- single handle: filter icon when closed (sits at the screen's right
         edge), close ✕ when open -->
    <div
      class="fp-toggle"
      (click)="toggleFilterPanel()"
      [title]="filterPanelOpen ? 'Close' : 'Filter'"
    >
      <mat-icon *ngIf="!filterPanelOpen" svgIcon="g_filter"></mat-icon>
      <span *ngIf="filterPanelOpen" class="fp-toggle-x">✕</span>
    </div>

    <h2 class="fp-title">Filter</h2>
    <hr class="fp-hr" />

    <div class="fp-body">
      <!-- Question search first: it is the filter a reviewer looking for one
           known question reaches for, and it is not in the chip strip's list. -->
      <div class="fp-field">
        <label class="filterLabelStyle">Question</label>
        <input
          class="fp-search"
          type="text"
          placeholder="Search question text"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange()"
        />
      </div>

      <!-- Same list as the badge strip, so the panel names every filter too.
           Until a filter's values are in, its label stands over an inert control
           rather than the field being left out. -->
      <div class="fp-field" *ngFor="let f of filters">
        <label class="filterLabelStyle">{{ f.label }}</label>

        <ng-select
          #scM
          [readonly]="!hasOptions(f)"
          class="ngSelection fp-select"
          [multiple]="true"
          [clearable]="false"
          [closeOnSelect]="false"
          [dropdownPosition]="'auto'"
          [appendTo]="'.filter-panel'"
          [items]="f.options"
          [ngModel]="f.checked"
          (ngModelChange)="f.checked = $event"
          (close)="onSelectClose(f)"
          [placeholder]="filterPlaceholder(f)"
        >
          <ng-template ng-header-tmp>
            <input
              class="searchFiler"
              type="text"
              placeholder="Search"
              (input)="scM.filter(onFilterText($event))"
            />
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            let-item$="item$"
            let-index="index"
          >
            <div class="form-check du-opt">
              <input
                style="accent-color: #1363df !important"
                id="opt-m-{{ index }}"
                type="checkbox"
                [checked]="item$.selected"
              />
              <label class="form-check-label">{{ item }}</label>
            </div>
          </ng-template>
          <ng-template ng-footer-tmp>
            <div class="d-flex align-items-center py-2" style="gap: 10px">
              <ng-container
                *ngTemplateOutlet="ieButtons; context: { f: f, sc: scM }"
              ></ng-container>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div class="fp-reset" *ngIf="anyPartial">
        <span class="chip reset-chip" (click)="resetFilters()">
          <span class="reset-x">✕</span> Reset
        </span>
      </div>
    </div>
  </aside>

  <!-- The KPI cards' shared help popover. One menu for the whole row rather than
       one per card — the cards render from an *ngFor, so a mat-menu inside it
       would be a menu per card. The panel below answers through icon-chart's own
       copy of this. -->
  <mat-menu #cardHelpMenu="matMenu">
    <div class="card-help" (click)="$event.stopPropagation()">
      <div class="card-help-title">{{ cardHelp?.info_header }}</div>
      <div class="card-help-body" [innerHtml]="cardHelp?.info_text"></div>
    </div>
  </mat-menu>
</div>
